import { Arquivo } from "@tivic-team/manager-ts/dist/grl";
import { DocumentoOcorrencia } from "@tivic-team/manager-ts/dist/ptc/entities/documento-ocorrencia.entity";
import { Documento } from "@tivic-team/manager-ts/dist/ptc/entities/documento.entity";
import { Fase } from "@tivic-team/manager-ts/dist/ptc/entities/fase.entity";
import { Usuario } from "@tivic-team/manager-ts/dist/seg";
export class RecursoDTO extends Documento{
    
    fase: Fase = void(0);
    documentoOcorrencia: DocumentoOcorrencia = void(0);
    usuario: Usuario = void(0);
    arquivo: Arquivo = void(0);
    cdAit: number = void(0);
}